module.exports = __webpack_public_path__ + "static/img/20200216151451qevv@2x.c8d3a555.png";